export default function createItems(array) {
  const item = array.map(({hex, rgb}) => {
    return `<div class="color-card">
                <div class="color-swatch" data-hex="${hex}" data-rgb="${rgb}" style="background-color: ${hex}"></div>
                <div class="color-meta">
                    <p>HEX: ${hex}</p>
                    <p>RGB: ${rgb}</p>
                </div>
            </div>`;
  }).join("");
  return item
}